import axios from 'axios'
import API from './API.js'

export default class Announcements extends API {
  constructor() {
    super('announcements')
  }

  async HomeAnnouncements(params) {
    try {
      const response = await axios.get('announcements/all', { params })
      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
}
